import { useCallback } from "react";

import { useMessengerStoreConversationStorage } from "./__internal__/useMessengerStoreConversationStorage";

export const useMessengerStoreGetConversationOrUndefined = () => {
  const { conversationByBrandToken } = useMessengerStoreConversationStorage();

  const hasConversationWithBrand = useCallback(
    (brandToken: string) => {
      return !!conversationByBrandToken?.get(brandToken);
    },
    [conversationByBrandToken]
  );

  return { hasConversationWithBrand };
};
